import { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import UnitDashboard from '../../components/Modules/ModulesDashboard';
import ModulesService from '../../services/ModulesService';

const Unit4Navigation = () => {
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const [modulesConfig, setModulesConfig] = useState([]);

  const IMAGES_ENDPOINT = login.cloudFront + 'images';

  const WorldMap = `${IMAGES_ENDPOINT}/Images/Worlds/WorldMap_Large_Unit4_5of5.png${login.cookie}`;

  const getModulesConfiguration = useCallback(
    (modules) => {
      const mappedModules = modules
        .filter((module) => module.unit === 4)
        .map((module) => {
          let config = {};

          if (module.name === 'Manners') {
            config = ModulesService.getModuleConfig({
              order: 0,
              currentModule: module,
              previousModule: null,
              totalDays: 9,
              bgImage: '/Module16Images/Unit4_Mod1BG.png',
              destiny: '/manners/navigation',
              title: 'Manners',
              character: 'Crab',
              welcomeVideo: 'b2dffdb76fbd4d0815856051a953/480.m3u8',
              login,
            });
            dispatch({ type: 'SET_MODULE16_INITIALSTATE', payload: module });
          }

          if (module.name === 'FriendsBullies') {
            config = ModulesService.getModuleConfig({
              order: 1,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'Manners'
              ),
              totalDays: 9,
              bgImage: '/Module17Images/Unit4_Mod2BG_Final.png',
              destiny: '/friendsbullies/navigation',
              title: 'Make Friends & Stop Bullying',
              character: 'Dog',
              welcomeVideo: '655148dddfc6adb456bfa18e2ea9/480.m3u8',
              login,
            });
            dispatch({
              type: 'SET_MODULE17_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'ResolveConflict') {
            config = ModulesService.getModuleConfig({
              order: 2,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'FriendsBullies'
              ),
              totalDays: 9,
              bgImage: '/Module18Images/Unit4_Mod3BG_Final.png',
              destiny: '/resolveconflict/navigation',
              title: 'Solve Problems with Friends',
              character: 'Lizard',
              welcomeVideo: '560aa4a4b86e5239fc3165a275f7/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE18_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'SelfAdvocacy') {
            config = ModulesService.getModuleConfig({
              order: 3,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'ResolveConflict'
              ),
              totalDays: 9,
              bgImage: '/Module19Images/Unit4_Mod4BG_No_Fences.png',
              destiny: '/selfadvocacy/navigation',
              title: 'Self-Advocacy',
              character: 'Monkey',
              welcomeVideo: '32a684831a96df18eeaf2d067c12/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE19_INITIALSTATE',
              payload: module,
            });
          }

          if (module.name === 'Caring') {
            config = ModulesService.getModuleConfig({
              order: 4,
              currentModule: module,
              previousModule: modules.find(
                (module) => module.name === 'SelfAdvocacy'
              ),
              totalDays: 9,
              bgImage: '/Module20Images/Unit4_Mod5BG-01.png',
              destiny: '/caring/navigation',
              title: 'Caring for Self, Others & the World',
              character: 'Bird',
              welcomeVideo: '8484fb6aff1505c13c86e02edbfd/480.m3u8',
              login,
            });

            dispatch({
              type: 'SET_MODULE20_INITIALSTATE',
              payload: module,
            });
          }

          return {
            ...module,
            ...config,
          };
        });
      setModulesConfig(mappedModules);
    },
    [dispatch, login]
  );
  
  const getStudentModules = useCallback(async () => {
    const data = await ModulesService.getStudentModules(login.endPoint);
    getModulesConfiguration(data.modules);
  }, [getModulesConfiguration]);

  useEffect(() => {
    getStudentModules();
  }, [getStudentModules]);

  return (
    <UnitDashboard
      modules={modulesConfig.sort(function (a, b) {
        return a.order - b.order;
      })}
      pageTitle='Behavioral & Social Awareness Skills'
      worldMapImage={WorldMap}
      grade={login.grade}
      unit={4}
    />
  );
};
export default Unit4Navigation;
